import type { HelpFile } from '../../types/help'
import { AttributeFormRendererTestIds } from '../../../testids/AttributeFormRendererTestIds'

export const attributeFormRendererHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [AttributeFormRendererTestIds.attributeSectionToggle]: 'Expand or collapse this group of attribute fields.',
  },
}
